import Store from '@/main/store';
import Router from '@/main/router';

import { ITraceableError } from '@/interfaces/Error';

import { EErrorType } from '@/helpers/enums';
import { pushEligibilityBlockToDatalayer, pushTraceableErrorToDatalayer } from '@/helpers/dataLayer';
import { errors } from '@/helpers/errorsMap';
import { errorsByBroker } from '@/helpers/paymentErrorByBrokerMap';
import { sendInteractEvent } from '@/helpers/events';

import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';

export const hideModal = (code: string | number = '', reload: boolean = false): void => {
  Store.commit('App/Error/hideError', code, { root: true });

  reload && window.location.reload();
};

export const getErrorByCode = (code: number | string): ITraceableError | undefined => {
  const codeError = errors.find((error: any) => error.code == code);

  return codeError;
};

export const getErrorByCodeAndType = (code: number | string, types: EErrorType[], paymentDetails?: [{ payment_method_code: string, broker: keyof typeof errorsByBroker}]): any => {
  if(paymentDetails && paymentDetails.length && types.includes(EErrorType.payment)) {
    const broker = paymentDetails[0] && paymentDetails[0].broker;

    const brokerErrors = broker && errorsByBroker[broker];
    const errorByBroker = brokerErrors && brokerErrors[code as keyof typeof brokerErrors];

    if(errorByBroker) return errorByBroker;
  }

  const errorsWithThisCode: ITraceableError[] = errors.filter((error: any) => error.code == code);

  let error: any;

  types.forEach((type: EErrorType) => {
    if (!error) {
      error = errorsWithThisCode.find((error: ITraceableError) => error.type === type);
    }
  });

  if (!error) {
    return {
      ...getDefaultErrorByType(types[0]),
      code,
    };
  }

  return error;
};

export const getDefaultErrorByType = (type: EErrorType): ITraceableError | undefined => {
  const errorByType = getErrorsByType(type);

  const codeError = errorByType && errorByType.find((error: any) => error.code === 'default');

  return codeError;
};

export const getErrorsByType = (type: EErrorType): ITraceableError[] | undefined => {
  return errors.filter((error: any) => error.type === type);
};

export const addError = (error: ITraceableError): void => {
  Store.commit('App/Error/addError', error, { root: true });
};

export const traceError = (error: ITraceableError): any => {
  if (error.type === EErrorType.eligibility) {
    const customerId = Store.getters['App/Customer/actaId'];
    const currentSlug = Router.currentRoute.params.slug || Router.currentRoute.params.contract_id;


    sendInteractEvent({ action: EInteractEventTrackerAction.CHK_ELIGIBILITY_FALSE });

    return pushEligibilityBlockToDatalayer({
      code: error.code,
      slug: currentSlug,
      acta_user_id: customerId,
    });
  }

  return pushTraceableErrorToDatalayer(error);
};
